import { Auth } from 'aws-amplify';
import axios from 'axios';

import { BASE_URL } from './env_constants';

export const httpClient = axios.create({
  baseURL: BASE_URL(),
});

httpClient.interceptors.request.use(async (request) => {
  const session = await Auth.currentSession();
  const jwt = session.getIdToken().getJwtToken();

  request.baseURL = BASE_URL();
  request.headers = request.headers ?? {};
  request.headers['Content-Type'] = 'application/json';
  request.headers['Authorization'] = `Bearer ${jwt}`;
  return request;
});
